import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import wx from 'weixin-js-sdk'
import 'amfe-flexible'
import VueWechatTitle from 'vue-wechat-title';
import shareCard from '@/components/examination(22524)/shareCard.vue'
import { Button, Icon, Toast, Sticky, Avatar, Popup, OverLay,Input } from "@nutui/nutui";
const app = createApp(App)
// createApp(App).use(store).use(router).use(VueWechatTitle).use(Button).use(Icon).use(Input).use(Toast).use(Sticky).use(Avatar).use(Popup).use(OverLay).component('share-card', shareCard).mount('#app')
app.config.globalProperties.$wx = wx
app.use(store).use(router)
app.use(VueWechatTitle)
app.use(Button).use(Icon).use(Input).use(Toast).use(Sticky).use(Avatar).use(Popup).use(OverLay).component('share-card', shareCard)
app.mount('#app')
